module.exports = __webpack_public_path__ + "static/img/LxwlyqjcL.61c40f0f.png";